let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3t09A")).then(() => parcelRequire('gI3DX'));